import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"
import Card from "@pathwright/ui/src/components/card/Card"
import CardHeader from "@pathwright/ui/src/components/card/CardHeader"
import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import ConnectStores from "lib/core/store/components/ConnectStores"
import React from "react"
import styled from "styled-components"
import OrderRegistrationButton from "../library/register/components/OrderRegistrationButton"

const CenteredContent = styled.div`
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

// TODO: REMOVE, this is no longer used, but keeping around for the group subscription deploy.
// should be safe to remove soon after that.
class FinishRegistrationCard extends React.Component {
  static initClass() {
    this.displayName = "FinishRegistrationCard"
  }

  constructor(props) {
    super(props)
    this.state = {
      loading: true
    }
  }

  render() {
    const { card, resource, offering } = this.props

    return (
      <Card card={card} navless style={{ width: 400 }}>
        {resource && offering ? (
          <>
            <CardHeader card={card} title={resource.name} resource={resource} />
            <BlankSlate
              icons={null}
              animateIcon
              icon="check"
              heading="You’re all set!"
              primaryAction={
                offering.permissions && offering.permissions.can_access
                  ? {
                      to: `/library/${resource.slug}/${offering.id}/path`,
                      children: "Get Started"
                    }
                  : null
              }
              footer={
                !offering.permissions || !offering.permissions.can_access ? (
                  <OrderRegistrationButton submitLabel="Complete Registration" />
                ) : null
              }
            />
          </>
        ) : (
          <LoadingCircle />
        )}
      </Card>
    )
  }
}

FinishRegistrationCard.initClass()

const mapStateToProps = function (state, ownProps) {
  const { resource, offering } = state.resourceStore.state

  return _.assign({}, ownProps, {
    resource,
    offering
  })
}

const stores = [
  { store: "resource", watch: ["resource", "offering", "registration"] }
]

export default ConnectStores(
  FinishRegistrationCard,
  stores,
  {},
  mapStateToProps
)
